export function getStytchToken() {
  // if a disambiguator exists grab tes token otherwise use the live token
  const subdomain = window.location.hostname.replace('www.', '').split('.')[0];
  if (subdomain && subdomain !== 'studio' && subdomain !== 'getcartwheel') {
    return 'public-token-test-2f151027-cec2-4b59-bbca-21cddf293393';
  } else {
    return 'public-token-live-cf97cbaf-ce0e-4168-97b3-26934649ecf0';
  }
}
